import { path } from 'ramda'
import { isObject } from '@/utils'

const transformCondtion = (newKey, oldKey, condition) => {
  return Object.fromEntries(
    Object.entries(condition).map(([key, value]) => {
      const result = key.replace(oldKey, newKey)
      return [result, isObject(value) ? transformCondtion(newKey, oldKey, value) : value]
    }),
  )
}
const transFormComponents = (components, newKey, oldKey) => {
  return components.map(c => {
    const newComponent = structuredClone(c)
    const condition = path(['options', 'condition'], newComponent)
    if (condition) {
      newComponent.options.condition = transformCondtion(newKey, oldKey, condition)
    }
    if (newComponent.component instanceof Array) {
      return {
        ...newComponent,
        component: transFormComponents(newComponent.component, newKey, oldKey),
      }
    }
    return newComponent
  })
}
function getCustomFieldsFromLayout(layout = [], customFieldSchemas, placement) {
  const data = structuredClone(customFieldSchemas)
  placement = (placement instanceof Array ? placement : [placement]).filter(Boolean)

  const hasInitLayout = layout.length

  //add fields that has display.cms to true. Is added last to layout ->  placed in correct position based on options.location in @kvass/custum-fields
  const placeInsideLayout = data.filter(i => {
    if (layout.find(l => l.key === i.key)) return
    const block = path(['block'], i)
    if (!block) return
    return path(['display', 'cms'], block) === true
  })

  layout = [...layout, ...placeInsideLayout]
  if (!Array.isArray(layout)) layout = []

  const result = layout
    .map(field => {
      if (!field) return

      const schema = data.find(c => {
        const blockKey = path(['block', 'key'], c) || c.key
        return [path(['data', 'reference'], field), field.key].includes(blockKey)
      })

      if (!schema) return

      let component = schema.component
      let options = schema.options || {}

      //remove location on fields that has no strict cms display and layout is defined
      if (path(['block', 'display', 'cms'], field) !== true && hasInitLayout) {
        options.location = null

        //remove settings fields in fields that is a copy from another field
        const isCopy = path(['data', 'reference'], field)
        if (isCopy && path(['block', 'added', 'remove', 'length'], schema)) {
          const newItem = path(['block', 'added', 'remove'], schema).reduce(
            (acc, currKey) => {
              acc.settings = (acc.settings || schema.settings || '').split(',').reduce((accS, currS) => {
                const [component, key, label] = currS.split(':')
                if (key === currKey) return accS
                return `${accS ? `${accS},` : ''}${currS}`
              }, '')

              acc.settingsLayout = (acc.settingsLayout || options.settingsLayout || '')
                .split('|')
                .reduce((accSL, currSL) => {
                  if (currSL.includes(currKey)) return accSL
                  return `${accSL ? `${accSL} | ` : ''}${currSL}`
                }, '')

              return acc
            },
            {
              settings: '',
              settingsLayout: '',
            },
          )

          schema.settings = newItem.settings

          options.settingsLayout = newItem.settingsLayout
        }
      }

      //transform condition with new key
      if (path(['condition'], options)) {
        options.condition = transformCondtion(field.key, schema.key, options.condition)
      }

      //tranform condition on each component with new key
      if (schema.component instanceof Array) {
        component = transFormComponents(schema.component, field.key, schema.key)
      }
      return {
        ...structuredClone(schema),
        options: structuredClone(options),
        component,
        key: field.key,
      }
    })
    .filter(Boolean)

  //place fields with a defined block.order at the given position (1-based). Others keep their relative order.
  const ordered = []
  const rest = []
  result.forEach(item => {
    const order = path(['block', 'display', 'order'], item)
    if (typeof order === 'number') ordered.push({ item, order })
    else rest.push(item)
  })

  ordered
    .sort((a, b) => a.order - b.order)
    .forEach(({ item, order }) => {
      const index = Math.min(Math.max(order - 1, 0), rest.length)
      rest.splice(index, 0, item)
    })

  //filter out duplicates by key, keeping the first occurrence
  const seen = new Set()
  return rest.filter(item => {
    if (seen.has(item.key)) return false
    seen.add(item.key)
    return true
  })
}

export { getCustomFieldsFromLayout }
